import { ReactComponent as Menu } from './menu.svg'
import { ReactComponent as CameraMenu } from './camera-menu.svg'
import { ReactComponent as CameraDisabledMenu } from './camera-disabled-menu.svg'
import { ReactComponent as GalleryMenu } from './gallery-menu.svg'
import { ReactComponent as RestartMenu } from './restart-menu.svg'
import { ReactComponent as FilesMenu } from './files-menu.svg'
import { ReactComponent as Microphone } from './microphone.svg'
import { ReactComponent as CheckInput } from './check-input.svg'
import { ReactComponent as Close } from './close.svg'
import { ReactComponent as Home } from './home.svg'
import { ReactComponent as Logo } from './logo.svg'
import { ReactComponent as Config } from './config.svg'
import { ReactComponent as Audio } from './audio.svg'
import { ReactComponent as Mute } from './mute.svg'
import { ReactComponent as ArrowRight } from './arrow-right.svg'
import { ReactComponent as Check } from './check.svg'
import { ReactComponent as X } from './x.svg'
import { ReactComponent as Next } from './next.svg'
import { ReactComponent as Previous } from './previous.svg'
import { ReactComponent as Team } from './team.svg'
import { ReactComponent as Blocked } from './blocked.svg'
import { ReactComponent as Gift } from './gift.svg'
import { ReactComponent as Diamond } from './diamond.svg'
import { ReactComponent as CheckPoint } from './check_point.svg'
import { ReactComponent as CurrentPoint } from './current_point.svg'
import { ReactComponent as DoneGroupPoint } from './done-group-point.svg'
import { ReactComponent as Zoom } from './zoom.svg'
import { ReactComponent as ArrowConnectionLine } from './arrow-connection-line.svg'
import { ReactComponent as Pencil } from './pencil-icon.svg'
import { ReactComponent as CheckIcon } from './check-icon.svg'
import { ReactComponent as GoogleIcon } from './google-icon.svg'

const IconSvg = ({ name, ...rest }) => {
  switch (name) {
    case 'menu': return <Menu {...rest} />
    case 'camera-menu': return <CameraMenu {...rest} />
    case 'camera-disabled-menu': return <CameraDisabledMenu {...rest} />
    case 'gallery-menu': return <GalleryMenu {...rest} />
    case 'restart-menu': return <RestartMenu {...rest} />
    case 'files-menu': return <FilesMenu {...rest} />
    case 'microphone': return <Microphone {...rest} />
    case 'check-input': return <CheckInput {...rest} />
    case 'close': return <Close {...rest} />
    case 'home': return <Home {...rest} />
    case 'logo': return <Logo {...rest} />
    case 'config': return <Config {...rest} />
    case 'audio': return <Audio {...rest} />
    case 'mute': return <Mute {...rest} />
    case 'arrow-right': return <ArrowRight {...rest} />
    case 'check': return <Check {...rest} />
    case 'x': return <X {...rest} />
    case 'next': return <Next {...rest} />
    case 'previous': return <Previous {...rest} />
    case 'team': return <Team {...rest} />
    case 'blocked': return <Blocked {...rest} />
    case 'gift': return <Gift {...rest} />
    case 'zoom': return <Zoom {...rest} />
    case 'diamond': return <Diamond {...rest} />
    case 'done-point': return <CheckPoint {...rest} />
    case 'current-point': return <CurrentPoint {...rest} />
    case 'done-group-point': return <DoneGroupPoint {...rest} />
    case 'arrow-connection-line': return <ArrowConnectionLine {...rest} />
    case 'pencil': return <Pencil {...rest} />
    case 'check-icon': return <CheckIcon {...rest} />
    case 'google-icon': return <GoogleIcon {...rest} />
    default: return null
  }
}

export default IconSvg
